(function (angular, numeral) {
	'use strict';

	angular.module('PinMeTo.fileManager').component('pmtAssetView', {
		templateUrl: 'pmtShared/filemanager/pmtAssetView.html',
		controller: AssetView,
		bindings: {
			prevState: '='
		}
	});

	AssetView.$inject = [
		'$http',
		'$stateParams',
		'$state',
		'pmtEnvService',
		'pmtAlertService',
		'pmtLoggerService',
		'$i18next'
	];

	//jshint maxparams: 7
	function AssetView(
		$http,
		$stateParams,
		$state,
		pmtEnvService,
		pmtAlertService,
		pmtLoggerService,
		$i18next
	) {
		const $ctrl = this;

		$ctrl.site = $stateParams.site;
		$ctrl.assetId = $stateParams.assetId;
		$ctrl.isVideo = false;
		$ctrl.isEditing = false;
		$ctrl.isLoading = false;
		$ctrl.isPlacesApp = pmtEnvService.isPlacesApp;

		const getMedia = () => {
			$ctrl.isLoading = true;
			$http
				.get(`api/${$ctrl.site}/media/asset/${$ctrl.assetId}`)
				.then(res => {
					$ctrl.isLoading = false;
					$ctrl.media = res.data.data;
					$ctrl.isVideo = !!(
						$ctrl.media &&
						$ctrl.media.contentType &&
						$ctrl.media.contentType.startsWith('video')
					);

					const hasUserName = $ctrl.media.uploadedBy && $ctrl.media.uploadedBy.name;
					$ctrl.uploadedBy = hasUserName ? $ctrl.media.uploadedBy.name : '--';
				})
				.catch(res => {
					const errMsg =
						res.data?.message ||
						res.data?.error?.message ||
						res.data ||
						res.message ||
						res.error?.message ||
						'Something unexpected happened. Please refresh or navigate to another page.';

					pmtLoggerService.exceptionHandler(errMsg, 'get media/all failed');
					pmtAlertService.alert({
						title: $i18next.t('general.error_occurred'),
						body: errMsg,
						confirm: () => {
							pmtAlertService.close();
						}
					});
				});
		};

		getMedia();

		$ctrl.formatSize = size => numeral(size).format('0.0b');
		$ctrl.toggleEditing = () => {
			if (!$ctrl.isEditing) {
				$ctrl.editName = $ctrl.media.name;
				$ctrl.editDescription = $ctrl.media.description;
			}
			$ctrl.isEditing = !$ctrl.isEditing;
		};
		$ctrl.cancelEdit = () => ($ctrl.isEditing = false);
		$ctrl.saveChanges = () => {
			$ctrl.isEditing = false;
			let data = {
				name: $ctrl.editName,
				description: $ctrl.editDescription
			};

			$http.put(`api/${$ctrl.site}/media/asset/${$ctrl.assetId}`, data).then(
				() => {
					$ctrl.media.name = data.name;
					$ctrl.media.description = data.description;
					getMedia();
				},
				err => {
					if (err.status === 403) {
						err.message = "You don't have sufficient permission to do this action";
					}
					pmtAlertService.errorAlert(err);
				}
			);
		};

		$ctrl.unDeleteMedia = () => {
			$http.put(`api/${$ctrl.site}/media/undelete/${$ctrl.assetId}`).then(() => {
				$state.go('site.AssetsList', $ctrl.prevState.params);
			});
		};

		$ctrl.close = () => {
			$state.go('site.AssetsList', $ctrl.prevState.params);
		};

		$ctrl.deleteMedia = () => {
			if (!$ctrl.media.deleted) {
				$http.delete(`api/${$ctrl.site}/media/${$ctrl.assetId}`).then(
					() => {
						$state.go('site.AssetsList', $ctrl.prevState.params);
					},
					err => {
						if (err.status === 403) {
							err.message = "You don't have sufficent permission to do this action";
						}
						pmtAlertService.errorAlert(err);
					}
				);
			} else {
				pmtAlertService.alert({
					title: $i18next.t('general.media_upload.confirm_delete_asset_title'),
					body: $i18next.t('general.media_upload.confirm_delete_asset'),
					confirmTitle: $i18next.t('general.yes'),
					cancelTitle: $i18next.t('general.no'),
					confirm: function () {
						$http.delete(`api/${$ctrl.site}/media/purge/${$ctrl.assetId}`).then(() => {
							pmtAlertService.close();
							$state.go('site.AssetsList', $ctrl.prevState.params);
						});
					},
					cancel: function () {
						pmtAlertService.close();
					}
				});
			}
		};
	}
})(window.angular, window.numeral);
